<template>
    <b-container fluid class="animated fadeIn">
        <h1>CONFIGURAÇÃO TIPO DE CRÉDITO / ASSUNTO</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button class="mx-1 fonte-branca" v-b-toggle.collapseOpcoesPesquisa variant="primary"><i class="fa fa-filter"></i> Opções de pesquisa</b-button>
                            <CompExibirOcultarColuna 
                                :fields="fields"
                                :showColunms="showColunms" 
                                @toggleColuna="toggleColuna" />
                        </div>
                    </div>
                    <div>
                        <b-collapse id="collapseOpcoesPesquisa" class="mt-2">
                            <b-card class="primary-semi p-2">
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group label="Filtrar por:" label-for="filtrarPor" class="text-label">
                                            <multiselect
                                                v-model="filtrarPor"
                                                :show-labels="false"
                                                :options="opcoesFiltro"
                                                :multiple="true"
                                                :close-on-select="false"
                                                :clear-on-select="false"
                                                :preserve-search="true"
                                                placeholder="Selecione"
                                                track-by="id"
                                                label="filtro"
                                            >
                                                <template slot="selection" slot-scope="{ values, search, isOpen }">
                                                    <span
                                                        class="multiselect__single"
                                                        v-if="values.length &amp;&amp; !isOpen"
                                                    >{{ values.length }} selecionado(s)</span>
                                                </template>
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 1).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group
                                                label="Tipo de Crédito:"
                                                label-for="tipoCredito">
                                            <multiselect
                                                    name="tipoCredito"
                                                    v-model="filtro.tipoCreditos"
                                                    :show-labels="false"
                                                    :options="dados.tiposCredito"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    placeholder="Selecione"
                                                    track-by="id"
                                                    label="nome"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 2).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group
                                                label="Assunto:"
                                                label-for="assunto">
                                            <multiselect
                                                    name="assunto"
                                                    v-model="filtro.assunto"
                                                    :show-labels="false"
                                                    :options="dados.assuntos"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    placeholder="Selecione"
                                                    track-by="codAssunto"
                                                    label="nome"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row v-if="(filtrarPor.filter(e => e.id == 3).length > 0)">
                                    <b-col xs="12" sm="12" md="12" lg="6" xl="6">
                                        <b-form-group
                                                label="Tipo Origem:"
                                                label-for="tipoOrigem">
                                            <multiselect
                                                    name="tipoOrigem"
                                                    v-model="filtro.tiposOrigem"
                                                    :show-labels="false"
                                                    :options="dados.tiposOrigem"
                                                    :multiple="true"
                                                    :close-on-select="false"
                                                    :clear-on-select="false"
                                                    :preserve-search="true"
                                                    placeholder="Selecione"
                                                    track-by="id"
                                                    label="nome"
                                            >
                                            </multiselect>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <hr>
                                <b-row>
                                    <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                                        <div class="d-flex justify-content-center align-items-center">
                                            <b-button class="ml-2" variant="secondary" @click="limparFiltro">
                                                <i class="fa fa-eraser"></i> Limpar
                                            </b-button>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card>
                        </b-collapse>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button variant="primary" class="fonte-branca ml-1" @click="filtrar">
                                <i class="fa fa-search"></i> Pesquisar
                            </b-button>
                            <b-button variant="primary" @click.prevent="incluir" class="fonte-branca ml-1">
                                <i class="fa fa-plus"></i> Incluir
                            </b-button>
                            <b-button variant="primary" class="fonte-branca ml-1" :disabled="selecteds.length !== 1" @click.prevent="alterar">
                                <i class="fa fa-pencil"></i> Alterar
                            </b-button>
                            <b-button variant="primary" class="fonte-branca ml-1" :disabled="selecteds.length !== 1" @click.prevent="exibir">
                                <i class="fa fa-eye"></i> Exibir
                            </b-button>
                            <b-button variant="primary" class="fonte-branca ml-1" :disabled="selecteds.length !== 1" @click.prevent="alterarSituacao">
                                <i class="fa fa-refresh"></i> Ativar/Inativar
                            </b-button>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <b-col xs="12">
                        <div>
                            <b-row class="d-flex justify-content-between">
                                <b-col>
                                </b-col>
                                <b-col>
                                    <CompPaginacao :configTable="configTable" />
                                </b-col>
                            </b-row>
                            <TabelaTipoCreditoAssunto
                                :resultado="resultado"
                                :fields="fields"
                                :configTable="configTable"
                                :selecteds="selecteds"
                                @sortingChanged="consultar"
                                @consultar="consultar" />
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <CompPaginacao :configTable="configTable" />
                                </b-col>
                            </b-row>
                        </div>
                    </b-col>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import CompExibirOcultarColuna from '../components/CompBotaoExibirOcultarColuna'
import CompPaginacao from '../components/CompPaginacao'
import TabelaTipoCreditoAssunto from './TabelaTipoCreditoAssunto'

export default {
    name: 'ManterTipoCreditoAssunto',
    components: {
        CompExibirOcultarColuna,
        CompPaginacao,
        TabelaTipoCreditoAssunto
    },
    data() {
        return {
            fields: [
                {
                    key: "selecionar",
                },
            ],
            showColunms: [],
            filtro: {
                assunto: [],
                tipoCreditos: [],
                tiposOrigem: []
            },
            dados: {
                tiposCredito: [],
                assuntos: [],
                tiposOrigem: []
            },
            filtrarPor: [],
            opcoesFiltro: [
                {
                    id: 1,
                    filtro: 'Tipo de Crédito'
                },
                {
                    id: 2,
                    filtro: 'Assunto'
                },
                {
                    id: 3,
                    filtro: 'Tipo Origem'
                }
            ],
            configTable: {
                perPage: 100,
                sortField: 'tipoCredito',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
            },
            resultado: [],
            selecteds: [],
        }
    },
    methods: {
        /**
         * Incluir
         */
        incluir(evt) {
            evt.preventDefault();
            this.$store.commit('setTipoCreditoAssunto', null);
            this.$router.push({ path: '/tipo-credito-assunto/editar' });
        },

        /**
         * Alterar
         */
        alterar(evt) {
            evt.preventDefault();
            if(this.selecteds[0]) {
                this.$store.commit('setTipoCreditoAssunto', this.selecteds[0]);
                this.$router.push({ path: '/tipo-credito-assunto/editar' });
            }
        },

        /**
         * Exibir
         */
        exibir(evt) {
            evt.preventDefault();
            if(this.selecteds[0]) {
                this.$store.commit('setTipoCreditoAssunto', this.selecteds[0]);
                this.$router.push({ path: '/tipo-credito-assunto/exibir' });
            }
        },

        /**
         * Consultar
         */
        async consultar() {
            this.selecteds = [];
            const urlApi = process.env.VUE_APP_ROOT_API;

            const filtro = this.obterFiltro();

            let perPageStr = `&perPage=${this.configTable.perPage}`;
            if(this.configTable.perPage === 'Todos') {
                perPageStr = '';
                this.configTable.currentPage = 1;
                this.configTable.rows = 0;
            }

            this.loadingEnter();
            axios.post(`${urlApi}/v1/tipoCreditoAssunto/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                this.resultado = response.data.resultado;
                if(this.configTable.perPage !== 'Todos') {
                    this.configTable.rows = response.data.rows
                }

                for(var i = 0; i < this.selecteds.length; i++) {
                    for(var j = 0; j < this.resultado.length; j++) {
                        if(this.selecteds[i].id == this.resultado[j].id) {
                            this.selecteds[i] = this.resultado[j];
                        }
                    }
                }
            }).finally(() => {
                this.loadingExit()
            });
        },

        /**
         * Obter filtro
         */     
        obterFiltro() {
            return {
                tipoCreditos: (this.filtrarPor.filter(e => e.id == 1).length > 0) ? this.filtro.tipoCreditos : null,
                assunto: (this.filtrarPor.filter(e => e.id == 2).length > 0) ? this.filtro.assunto : null,
                tiposOrigem: (this.filtrarPor.filter(e => e.id == 3).length > 0) ? this.filtro.tiposOrigem : null,

            }
        },

        /**
         * Limpar os filtros de pesquisa
         */
        limparFiltro() {
            this.filtro = {
                assunto: [],
                tipoCreditos: [],
                tiposOrigem: []
            };
            this.filtrarPor = [];
            this.filtrar();
        },

        /**
         * Filtrar a consulta
         */
        filtrar() {
            this.configTable.currentPage = 1;
            this.configTable.rows = 0;
            this.configTable.checkedAll = false;
            this.resultado = [];
            this.selecteds = [];
            this.consultar();
        },
        toggleColuna(i) {
            let ativo;
            if(this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1);
                this.fields[i].thClass = 'd-none';
                this.fields[i].tdClass = 'd-none';
                ativo = false;
            } else {
                this.showColunms.push(i);
                this.fields[i].thClass = '';
                this.fields[i].tdClass = '';
                ativo = true;
            }

            this.refreshConfigColunm(i, ativo);
        },
        async refreshConfigColunm(i, ativo) {
            const token = JSON.parse(this.$store.getters.getUser).token.access_token;

            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo,
            };
            const urlApi = process.env.VUE_APP_ROOT_API;
            axios.post(`${urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).catch((error) => {
                this.exibirErro(error);
            })          
        },
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API;

            axios.get(`${urlApi}/v1/parametros/listarTipoCredito`)
            .then(response => {
              this.dados.tiposCredito = response.data;
            })
        },
        async listarAssuntos() {
            const urlApi = process.env.VUE_APP_ROOT_API;

            axios.get(`${urlApi}/v1/tipoCreditoAssunto/listarAssuntos`)
            .then(response => {
              this.dados.assuntos = response.data;
            })
        },
        async listarTipoOrigem() {
            const urlApi = process.env.VUE_APP_ROOT_API;

            axios.get(`${urlApi}/v1/tipoCreditoAssunto/listarTipoOrigem`)
            .then(response => {
                this.dados.tiposOrigem = response.data;
            })
        },
        async obterConfiguracaoUsuario() {
            const urlApi = process.env.VUE_APP_ROOT_API;
            const token = JSON.parse(this.$store.getters.getUser).token.access_token;
            const funcionalidade = 'tipoCreditoAssunto';

            this.loadingEnter()
            axios.get(`${urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                response.data.forEach((field, i) => {
                    if(field.ativo) {
                        this.showColunms.push(i + 1)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        sortable: true,
                        sortDirection: "desc",
                        class: 'justify-content-center',
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            })
        },

        async alterarSituacao() {
            const urlApi = process.env.VUE_APP_ROOT_API;
            const token = JSON.parse(this.$store.getters.getUser).token.access_token;

            let selecionado = this.selecteds[0];
            this.selecteds = [];

            this.loadingEnter();
            if(selecionado.status == 'Inativo') {
                await axios.post(`${urlApi}/v1/tipoCreditoAssunto/verificarExistenciaTipoCredito`, selecionado, {
                    headers: {
                        'Authorization': token,
                        'Content-Type': 'application/json',
                    }
                })
                .then(response => {
                    if(response.data) {
                        this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: [`Não foi possível executar a ação pois já existe um registro ativo para o mesmo Tipo de Crédito.`] });
                        window.scrollTo(0,0);
                        this.loadingExit();
                        return
                    }

                    this.executarAlterarSituacao(selecionado);
                }).catch((error) => {
                    this.exibirErro(error);
                    this.loadingExit();
                });
            } else {
                this.executarAlterarSituacao(selecionado);
            }
        },

        async executarAlterarSituacao(selecionado) {
            const urlApi = process.env.VUE_APP_ROOT_API;
            const token = JSON.parse(this.$store.getters.getUser).token.access_token;

            await axios.post(`${urlApi}/v1/tipoCreditoAssunto/alterarStatus`, selecionado, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                if(response.data) {
                    this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: [`${response.data.message}`] });
                    window.scrollTo(0,0);
                    return
                }
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Operação realizada com sucesso!!!'] });
                this.consultar();
            }).catch((error) => {
                this.exibirErro(error);
                this.loadingExit();
            });
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingEnter() {
            this.configTable.load = true;
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingExit() {
            this.configTable.load = false;
        }
    },
    watch: {
        perPage() {
            this.configTable.currentPage = 1;
            this.consultar();
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage;
        },
    },
    mounted() {
        this.$store.commit("setMessages", {});

        const msgTipoCreditoAssunto = this.$store.getters.getMsgTipoCreditoAssunto;
        if(msgTipoCreditoAssunto) {
            this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: [msgTipoCreditoAssunto] });
            this.$store.commit("setMsgTipoCreditoAssunto", null);
        }

        this.obterConfiguracaoUsuario();
        this.listarTipoCredito();
        this.listarAssuntos();
        this.listarTipoOrigem();

        this.consultar();
    }
    
}
</script>

<style scoped>

</style>